<template>
  <button
    type="button"
    class="group flex w-full gap-3 transition text-start"
    :class="[
      variant === 'page'
        ? 'px-4 py-3.5 sm:px-5 border-b border-slate-100 dark:border-slate-800/80 last:border-b-0 hover:bg-slate-50/80 dark:hover:bg-slate-800/40'
        : 'px-3 py-2.5 rounded-xl hover:bg-slate-50 dark:hover:bg-slate-800/80',
      isUnread(notification) && variant !== 'page'
        ? 'bg-primary/5 dark:bg-primary/10'
        : '',
      isUnread(notification) && variant === 'page'
        ? 'bg-primary/[0.03] dark:bg-primary/5'
        : '',
    ]"
    :dir="textDir"
    @click="$emit('select', notification)"
  >
    <span
      class="flex shrink-0 items-center justify-center rounded-xl text-primary ring-1"
      :class="[
        variant === 'page' ? 'w-11 h-11' : 'w-10 h-10',
        isUnread(notification)
          ? 'bg-primary/12 ring-primary/20'
          : 'bg-slate-100 dark:bg-slate-800 ring-slate-200/60 dark:ring-slate-700/60',
      ]"
    >
      <i
        class="mdi"
        :class="[
          categoryIcon(notification.category),
          variant === 'page' ? 'text-[20px]' : 'text-[18px]',
        ]"
      ></i>
    </span>

    <span class="flex-1 min-w-0">
      <span class="flex flex-wrap items-center gap-x-2 gap-y-1">
        <span
          class="text-sm leading-snug text-start"
          :class="
            isUnread(notification)
              ? 'font-semibold text-slate-900 dark:text-white'
              : 'font-medium text-slate-700 dark:text-slate-200'
          "
        >
          <span
            v-if="isUnread(notification)"
            class="inline-block w-1.5 h-1.5 rounded-full bg-primary align-middle"
            :class="lang === 'ar' ? 'ms-1.5' : 'me-1.5'"
          ></span>
          {{ notification.title }}
        </span>
        <span
          v-if="variant === 'page' && notification.category"
          class="inline-flex items-center px-2 py-0.5 text-[10px] font-medium rounded-md bg-slate-100 dark:bg-slate-800 text-slate-500 dark:text-slate-400"
        >
          {{ categoryLabel }}
        </span>
      </span>

      <span
        v-if="notification.message"
        class="block mt-1 text-xs leading-relaxed text-slate-500 dark:text-slate-400 line-clamp-2 text-start"
        :dir="textDir"
      >
        {{ notification.message }}
      </span>

      <span
        class="block mt-1.5 text-[10px] text-slate-400 tabular-nums text-start"
        :dir="textDir"
      >
        {{ formatNotificationTime(notification.created_at, lang) }}
      </span>
    </span>

    <span
      v-if="variant === 'page'"
      class="flex shrink-0 items-center self-center text-slate-300 dark:text-slate-600 group-hover:text-primary transition-colors"
    >
      <i
        class="mdi text-[20px]"
        :class="lang === 'ar' ? 'mdi-chevron-left' : 'mdi-chevron-right'"
      ></i>
    </span>
  </button>
</template>

<script setup>
import { computed } from "vue";
import {
  categoryIcon,
  formatNotificationTime,
  isUnread,
} from "@/utils/notification";

const props = defineProps({
  notification: { type: Object, required: true },
  lang: { type: String, default: "ar" },
  variant: { type: String, default: "dropdown" },
  t: { type: Function, default: () => (k) => k },
});

defineEmits(["select"]);

const textDir = computed(() => (props.lang === "ar" ? "rtl" : "ltr"));

const categoryLabel = computed(() => {
  const cat = props.notification.category;
  if (cat === "ticket") return props.t("notifications_tab_tickets");
  if (cat === "consultation") return props.t("notifications_tab_consultations");
  if (cat === "negotiation") return props.t("notifications_tab_negotiations");
  return cat;
});
</script>
